import { render, staticRenderFns } from "./TurnValueEditorModal.vue?vue&type=template&id=2d1477db&scoped=true&lang=pug"
import script from "./TurnValueEditorModal.vue?vue&type=script&lang=js"
export * from "./TurnValueEditorModal.vue?vue&type=script&lang=js"
import style0 from "./TurnValueEditorModal.vue?vue&type=style&index=0&id=2d1477db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1477db",
  null
  
)

export default component.exports